import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowBoxRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconArrowBoxRight"><Path fillRule="evenodd" clipRule="evenodd" d="M19 5L14 5V3L21 3L21 21H14V19H19L19 5ZM11 7.08579L15.9142 12L11 16.9142L9.58579 15.5L12.0858 13H3V11H12.0858L9.58579 8.5L11 7.08579Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowBoxRight;
